import { Box, Button, Icon } from '@chakra-ui/react';
import { MdComputer } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { usePwaInstall } from '../../../../hooks/PwaInstallContext';

/**
 * Botón lateral para instalar o abrir la PWA.
 * - Se muestra si puede instalar (deferredPrompt).
 * - O si ya está instalada pero estás en navegador (abrir app).
 */
export const PwaInstallButton = () => {
  const { t } = useTranslation();
  const {
    canSuggest,
    isInstalled,
    promptInstall,
  } = usePwaInstall();

  const handleClick = async () => {
    try {
      if (canSuggest) {
        await promptInstall(); // <- llama a .prompt() y limpia el evento en el contexto
      } else if (isInstalled) {
        window.location.href = '/';
      }
    } catch (err) {
      console.error('[PWA install]', err);
    }
  };

  // Mostrar si podemos sugerir instalación o si ya está instalada (abrir app)
  if (!canSuggest && !isInstalled) return null;
  const label = canSuggest ? t('Install app') : t('Open app');

  return (
    <Box px={4} mt={4}>
      <Button
        w="100%"
        leftIcon={<Icon as={MdComputer} />}
        colorScheme="teal"
        variant="outline"
        onClick={handleClick}
      >
        {label}
      </Button>
    </Box>
  );
};
